import { render, staticRenderFns } from "./DocumentStart.vue?vue&type=template&id=819465d4&scoped=true"
import script from "./DocumentStart.vue?vue&type=script&lang=js"
export * from "./DocumentStart.vue?vue&type=script&lang=js"
import style0 from "./DocumentStart.vue?vue&type=style&index=0&id=819465d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819465d4",
  null
  
)

export default component.exports